import { FC } from 'react';
import { Control, FieldErrors, UseFormSetValue } from 'react-hook-form';
import { EmailBodyField } from '@/features/email-flows/components/EmailBodyField';
import { EmailSubjectField } from '@/features/email-flows/components/EmailSubjectField';
import { useBroadcastEditorStore } from '../stores';
import type { BroadcastFormData } from '../validations/broadcastForm';
import { GeneratedDraftFeedback } from './GeneratedDraftFeedback';

interface BroadcastEmailContentProps {
    control: Control<BroadcastFormData>;
    errors: FieldErrors<BroadcastFormData>;
    setValue: UseFormSetValue<BroadcastFormData>;
    disabled: boolean;
}

export const BroadcastEmailContent: FC<BroadcastEmailContentProps> = ({ control, errors, setValue, disabled }) => {
    const templateVariables = useBroadcastEditorStore(state => state.templateVariables);
    const templateDefaults = useBroadcastEditorStore(state => state.templateDefaults);

    return (
        <div className='flex flex-col gap-6'>
            <EmailSubjectField
                control={control}
                errors={errors}
                disabled={disabled}
                templateVariables={templateVariables}
            />
            <EmailBodyField
                control={control}
                errors={errors}
                setValue={setValue}
                disabled={disabled}
                templateVariables={templateVariables}
                templateDefaults={templateDefaults}
            />
            <GeneratedDraftFeedback />
        </div>
    );
};
